<template>
  <div class="flex-start-start width--max-content position-relative">
    <b-img-lazy
      v-if="isImage"
      class="width-48 height-48 border-radius-8 background-light-gray margin-left-8 margin-top-5"
      :src="src"
      :onerror="`this.src='${defaultImage}';this.classList.add('padding-13')`"
    />

    <div class="color-complementary-100 font-size-14" :class="leftBoxClass">
      <span class="color-complementary-400"> {{ fullName }} </span>
      |
      <CopyTextWrapper
        :text="parvandehNumber"
        textClass="color-complementary-200 cursor--pointer"
      />
      <div class="color-complementary-300 font-size-12">
        {{ firstCaption }}
      </div>
      <div class="color-complementary-300 font-size-12">
        {{ secondCaption }}
      </div>
    </div>
  </div>
</template>

<script>
import CopyTextWrapper from "@/components/re-design/copy-text-wrapper/CopyTextWrapper.vue";
import { generateConfig } from "@/shared/utils";
import { toRefs } from "vue";
export default {
  components: { CopyTextWrapper },
  props: {
    fullName: {
      type: String,
      default: "",
    },
    parvandehNumber: {
      type: [Number, String],
      default: "",
    },
    firstCaption: {
      type: String,
      default: "",
    },
    secondCaption: {
      type: String,
      default: "",
    },
    src: {
      type: String,
      default: "",
    },
    isImage: {
      type: Boolean,
      default: true,
    },
    leftBoxClass: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    // generate props data
    const {
      fullName,
      parvandehNumber,
      firstCaption,
      secondCaption,
      src,
      leftBoxClass,
    } = toRefs(props);

    const defaultImage = generateConfig([
      "images",
      "shared",
      "redesign",
      "empty",
      "noUser",
    ]);

    // return data to be used in template
    return {
      fullName,
      parvandehNumber,
      firstCaption,
      secondCaption,
      src,
      leftBoxClass,
      defaultImage,
    };
  },
};
</script>
